import { Button } from '@grubhubprod/gh-cookbook-react';
import React, { ReactNode } from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { GROUP_ORDERS_HREF } from './groupOrdersAction.constants';

interface GroupOrdersActionLinkButtonProps {
  children?: ReactNode;
}

export function GroupOrdersActionLinkButton({
  children,
}: GroupOrdersActionLinkButtonProps): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Button
      variant="secondary"
      buttonSize="medium"
      block={isPhone}
      onClick={() => {
        window.open(GROUP_ORDERS_HREF, '_blank', 'noopener,noreferrer');
      }}
    >
      {children}
    </Button>
  );
}
